import DataGrid from './data-grid';

export default DataGrid;
